import * as React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import Container from '@mui/material/Container';
import { companyDetails } from 'utils/companyDetails';


function PolicyHeader() {
  
  return (
    <AppBar position="static" className="bgColorBlue navAlign">
      <Container maxWidth="xl" className='height100px'>
        <Toolbar disableGutters>
          <img src={companyDetails?.companyBlueLogo} alt='blueLogo' className='logoImage marginTop'/>  
        </Toolbar>
      </Container>
    </AppBar>
    // <>
    // {/* <div className="bgColorBlue navAlign height100px">
    // <img src={blueLogo} alt='blueLogo' className='logoImage marginTop'/>  
    // </div> */}
    // </>
  );
}
export default PolicyHeader;